import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';
import { GuestGuard } from '../../../_core/_guard/guest.guard';

const routes: Routes = [{ path: 'login', canActivate: [GuestGuard], component: LoginComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
